import React, { useState, useEffect, useMemo, useContext } from "react";
import Swal from "sweetalert2";
import { AppContext } from "../contexts/appContext";
import {
  Container,
  Typography,
  Box,
  Button,
  TextField,
} from "@material-ui/core";
import { authAPI } from "../services/AuthService";
import { checkPasswordStrength } from "../utils/config.js";

const ChangePassword = (props) => {
  const { user } = useContext(AppContext);
  useEffect(() => {
    document.title = `Com7 Merchandise - Change Password`;
    if (!user?.Email) {
      Swal.fire({
        icon: "error",
        confirmButtonColor: "#f27474",
        html: `<span class="colorWhite">กรุณาติดต่อ Admin เพื่อตั้งค่า Email.</span>`,
        backdrop: "transparent",
        background: "rgba(0,0,0,.75)",
        customClass: {
          icon: "switch",
        },
        width: "28rem",
        timer: 3000,
      });
    }
  }, [user]);
  const [loading, setLoading] = useState(false);
  const [otpData, setOtpData] = useState(null);
  const [time, setTime] = useState(0);
  const [oldPassword, setOldPassword] = useState("");
  const [password, setPassword] = useState("");
  const [rePassword, setRePassword] = useState("");
  const [otp, setOtp] = useState("");
  const checkStrong = useMemo(
    () => checkPasswordStrength(password),
    [password]
  );
  const getOTPFuncition = async (e) => {
    e.preventDefault();
    const { isConfirmed } = await Swal.fire({
      title: "คุณแน่ใจ ?",
      text: `ยืนยันการส่ง OTP ในยัง Email : ${user?.Email}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#56A834",
      cancelButtonColor: "#d33",
      confirmButtonText: "แน่ใจ",
      cancelButtonText: "ยังก่อน",
    });
    if (!isConfirmed) return;
    setLoading(true);
    authAPI
      .regenerate_otp({
        oldPassword,
      })
      .then(async (res) => {
        if (res.status == 200) {
          setOtpData(res.message);
          setTime(600);
        } else {
          Swal.fire({
            icon: "error",
            confirmButtonColor: "#f27474",
            html: `<span class="colorWhite">${res.message}</span>`,
            backdrop: "transparent",
            background: "rgba(0,0,0,.75)",
            customClass: {
              icon: "switch",
            },
            width: "28rem",
            timer: 3000,
          });
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          confirmButtonColor: "#f27474",
          html: `<span class="colorWhite">${error.message}</span>`,
          backdrop: "transparent",
          background: "rgba(0,0,0,.75)",
          customClass: {
            icon: "switch",
          },
          width: "28rem",
          timer: 3000,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const PasswordFunction = async () => {
    try {
      const { isConfirmed } = await Swal.fire({
        title: "คุณแน่ใจ ?",
        text: "ยืนยันการเปลี่ยนรหัสผ่าน",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#56A834",
        cancelButtonColor: "#d33",
        confirmButtonText: "แน่ใจ",
        cancelButtonText: "ยังก่อน",
      });
      if (!isConfirmed) return;
      setLoading(true);
      const { status, message } = await authAPI.ChangePassword({
        _id: otpData._id,
        newPassword: password,
        confirmPassword: rePassword,
      });
      if (status != 200) throw { message };
      await Swal.fire({
        icon: "success",
        confirmButtonColor: "#f27474",
        html: `<span class="colorWhite">เปลี่ยนรหัสผ่านสำเร็จ</span>`,
        backdrop: "transparent",
        background: "rgba(0,0,0,.75)",
        width: "28rem",
        timer: 3000,
      });
      setOtpData(null);
      setTime(0);
      setOldPassword("");
      localStorage.setItem("Token", message);
    } catch (error) {
      Swal.fire({
        icon: "error",
        confirmButtonColor: "#f27474",
        html: `<span class="colorWhite">${error.message}</span>`,
        backdrop: "transparent",
        background: "rgba(0,0,0,.75)",
        customClass: {
          icon: "switch",
        },
        width: "28rem",
        timer: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  const showTime = useMemo(() => {
    const min = Math.floor(time / 60);
    const sec = time % 60;
    return `${min.toString().padStart(2, "0")}:${sec
      .toString()
      .padStart(2, "0")}`;
  }, [time]);

  useEffect(() => {
    let interval;
    if (time > 0) {
      interval = setInterval(() => {
        setTime((old) => old - 1);
      }, 1000);
    }
    return () => {
      clearInterval(interval);
    };
  }, [time]);

  return (
    <React.Fragment>
      <Container
        style={{ paddingLeft: "0", paddingRight: "0", paddingTop: "2rem" }}
      >
        <Typography
          component="div"
          style={{ backgroundColor: "white", borderRadius: "10px" }}
        >
          <Container style={{ marginTop: "10px", height: "10%" }}>
            <Typography variant="h4" style={{ fontWeight: "bold" }}>
              {" "}
              Change Password
            </Typography>
          </Container>
          <Container
            style={{ display: "flex", padding: "0px 25px", height: "90%" }}
          >
            <Box color="primary.main">
              <div style={{ marginTop: "24px" }}>
                {!otpData && (
                  <>
                    <div className="form-outline mb-4">
                      <label htmlFor="oldPassword">กรอกรหัสผ่านเก่า</label>{" "}
                      <TextField
                        fullWidth
                        label="oldPassword..."
                        id="oldPassword"
                        type="password"
                        value={oldPassword}
                        onChange={(e) => setOldPassword(e.target.value)}
                      />
                    </div>
                    <Button
                      type="submit"
                      variant="contained"
                      style={{
                        margin: "2%",
                        backgroundColor: "rgb(91, 184, 70)",
                        color: "whitesmoke",
                      }}
                      size="small"
                      onClick={getOTPFuncition}
                      disabled={!oldPassword || loading}
                    >
                      ยืนยัน
                    </Button>
                  </>
                )}
                {!!otpData && (
                  <>
                    <p>
                      {" "}
                      (Ref. Code{" "}
                      <span style={{ fontWeight: 600 }}>{otpData.ref}</span>)
                    </p>
                    <div className="form-outline mb-4">
                      <label htmlFor="OTP">กรอกรหัส OTP</label>{" "}
                      <TextField
                        fullWidth
                        label="OTP"
                        id="OTP"
                        type="text"
                        value={otp}
                        onChange={(e) => setOtp(e.target.value)}
                      />
                    </div>
                    <div className="form-outline mb-4">
                      <label htmlFor="password">กรอกรหัสผ่านใหม่</label>{" "}
                      <TextField
                        fullWidth
                        label="Password"
                        id="password"
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                      />
                    </div>
                    <div className="form-outline mb-4">
                      <label htmlFor="rePassword">
                        กรอกรหัสผ่านใหม่อีกครั้ง
                      </label>{" "}
                      <TextField
                        fullWidth
                        label="Re-Password"
                        id="rePassword"
                        type="password"
                        value={rePassword}
                        onChange={(e) => setRePassword(e.target.value)}
                      />
                    </div>

                    {!!password &&
                      (password != rePassword || !!checkStrong.length) && (
                        <div
                          style={{
                            backgroundColor: "#fef2f2",
                            border: "1px solid #fca5a5",
                            color: "#b91c1c",
                            padding: "16px",
                            borderRadius: "8px",
                            maxWidth: "400px",
                            fontFamily: "sans-serif",
                          }}
                        >
                          <div
                            style={{
                              fontWeight: "bold",
                              marginBottom: "8px",
                            }}
                          >
                            🚫 รหัสผ่านของคุณไม่ปลอดภัย:
                          </div>
                          <ul
                            style={{
                              paddingLeft: "20px",
                              margin: 0,
                            }}
                          >
                            {password != rePassword && (
                              <li
                                style={{
                                  marginBottom: "6px",
                                }}
                              >
                                รหัสผ่านไม่ตรงกัน
                              </li>
                            )}
                            {checkStrong.map((res) => (
                              <li
                                key={`password-err-${res}`}
                                style={{
                                  marginBottom: "6px",
                                }}
                              >
                                {res}
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    <div style={{ display: "flex", gap: "1px" }}>
                      <Button
                        type="submit"
                        variant="contained"
                        style={{
                          margin: "2%",
                          backgroundColor: "rgb(91, 184, 70)",
                          color: "whitesmoke",
                        }}
                        size="small"
                        onClick={getOTPFuncition}
                        disabled={!oldPassword || loading}
                      >
                        {time > 0
                          ? `ขอ OTP ได้อีกครั้งในเวลา ${showTime}`
                          : "🔄 ส่งรหัสOTPอีกครั้ง"}
                      </Button>
                      <Button
                        simple
                        type="submit"
                        color={`${
                          password != rePassword ||
                          !!checkStrong.length ||
                          loading
                            ? "danger"
                            : "primary"
                        }`}
                        style={{
                          margin: "2%",
                          boxShadow: `0 5px 5px -50px ${
                            password != rePassword ||
                            !!checkStrong.length ||
                            loading
                              ? "lightgray"
                              : "#6ab23a"
                          }, 0 2px 15px -5px ${
                            password != rePassword ||
                            !!checkStrong.length ||
                            loading
                              ? "lightgray"
                              : "#6ab23a"
                          },0 12px 20px -10px ${
                            password != rePassword ||
                            !!checkStrong.length ||
                            loading
                              ? "lightgray"
                              : "#6ab23a"
                          }`,
                        }}
                        size="lg"
                        disabled={
                          password != rePassword ||
                          !!checkStrong.length ||
                          loading
                        }
                        onClick={PasswordFunction}
                      >
                        ยืนยัน
                      </Button>
                    </div>
                  </>
                )}
              </div>
            </Box>
          </Container>
        </Typography>
      </Container>
    </React.Fragment>
  );
};
export default ChangePassword;
